var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { getDefaultAsyncWrapperObj, getCompletedAsyncWrapperObj, AsyncRequestStatus } from "@ane/core/lib/models";
import myActivitiesActionTypes from "./MyActivitiesActionTypes.js";
import { ExperimentPivots } from "./MyActivitiesUserContext.js";
const defaultSubState = __spreadProps(__spreadValues({}, getDefaultAsyncWrapperObj()), {
  data: {
    items: null,
    scorecard_links: [],
    experiment_status: {}
  }
});
const getDefaultState = {
  new: defaultSubState,
  running: defaultSubState,
  completed: defaultSubState,
  userContext: { pivot: ExperimentPivots.new }
};
const updateGetAllExps = (state, actionResult) => {
  const queryType = actionResult.payload.queryType;
  return __spreadProps(__spreadValues({}, state), {
    [queryType]: __spreadProps(__spreadValues(__spreadValues({}, state[queryType]), getCompletedAsyncWrapperObj(actionResult.payload.data.Results, actionResult.payload.data.Error)), {
      data: __spreadProps(__spreadValues({}, state[queryType].data), {
        items: getCompletedAsyncWrapperObj(actionResult.payload.data.Results, actionResult.payload.data.Error).data
      })
    })
  });
};
const updateScoreCards = (state, actionResult) => {
  const queryType = actionResult.payload.queryType;
  return __spreadProps(__spreadValues({}, state), {
    [queryType]: __spreadProps(__spreadValues({}, state[queryType]), {
      data: __spreadProps(__spreadValues({}, state[queryType].data), {
        scorecard_links: actionResult.payload.data
      })
    })
  });
};
const setUserContext = (state, actionResult) => {
  return __spreadProps(__spreadValues({}, state), {
    userContext: actionResult.payload
  });
};
const updateStatusData = (state, actionResult) => {
  const queryType = actionResult.payload.queryType;
  return __spreadProps(__spreadValues({}, state), {
    [queryType]: __spreadProps(__spreadValues({}, state[queryType]), {
      data: __spreadProps(__spreadValues({}, state[queryType].data), {
        experiment_status: actionResult.payload.data
      })
    })
  });
};
const updateLoading = (state, actionResult) => {
  const queryType = actionResult.payload.queryType;
  return __spreadProps(__spreadValues({}, state), {
    [queryType]: __spreadProps(__spreadValues({}, state[queryType]), {
      status: AsyncRequestStatus.Pending
    })
  });
};
const MyActivitiesReducer = (state = getDefaultState, actionResult) => {
  switch (actionResult.type) {
    case myActivitiesActionTypes.SET_USER_CONTEXT:
      return setUserContext(state, actionResult);
    case myActivitiesActionTypes.GET_MY_EXPS:
      return updateLoading(state, actionResult);
    case myActivitiesActionTypes.UPDATE_MY_EXPS:
      return updateGetAllExps(state, actionResult);
    case myActivitiesActionTypes.UPDATE_SCORE_CARDS:
      return updateScoreCards(state, actionResult);
    case myActivitiesActionTypes.UPDATE_STATUS_DATA:
      return updateStatusData(state, actionResult);
    default:
      return state;
  }
};
export {
  MyActivitiesReducer,
  MyActivitiesReducer as default
};
//# sourceMappingURL=MyActivitiesReducer.js.map
